import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI, getErrorMessage } from '../lib/api';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [userType, setUserType] = useState('coach');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await authAPI.forgotPassword({ email, user_type: userType });
      setSent(true);
      toast.success('Email inviata!');
    } catch (error) {
      toast.error(getErrorMessage(error, 'Errore nell\'invio dell\'email'));
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#09090b] px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div className="text-center">
            <h1 className="text-4xl font-black text-[#ccff00] tracking-tight mb-2">
              Trainers
            </h1>
          </div>

          <div className="glass-card p-8 rounded-sm text-center">
            <CheckCircle className="w-16 h-16 text-[#ccff00] mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-white mb-4">Email Inviata!</h2>
            <p className="text-zinc-400 mb-6">
              Se l'indirizzo email è registrato, riceverai un link per reimpostare la password.
              Controlla anche la cartella spam.
            </p>
            <Link to="/login">
              <Button className="w-full bg-[#ccff00] text-black hover:bg-[#b3e600] font-bold uppercase tracking-wide rounded-sm h-12">
                Torna al Login
              </Button>
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090b] px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h1 className="text-4xl font-black text-[#ccff00] tracking-tight mb-2">
            Trainers
          </h1>
          <p className="text-zinc-400">Recupera la tua password</p>
        </div>

        <div className="glass-card p-8 rounded-sm space-y-6">
          <Link to="/login" className="flex items-center text-zinc-400 hover:text-white transition-colors">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Torna al login
          </Link>

          <div className="text-center">
            <Mail className="w-12 h-12 text-[#ccff00] mx-auto mb-4" />
            <p className="text-zinc-400 text-sm">
              Inserisci la tua email e ti invieremo un link per reimpostare la password.
            </p>
          </div>

          <Tabs value={userType} onValueChange={setUserType} className="w-full">
            <TabsList className="grid w-full grid-cols-2 bg-zinc-900">
              <TabsTrigger 
                value="coach" 
                className="data-[state=active]:bg-[#ccff00] data-[state=active]:text-black"
              >
                Allenatore
              </TabsTrigger>
              <TabsTrigger 
                value="athlete" 
                className="data-[state=active]:bg-[#ccff00] data-[state=active]:text-black"
              >
                Atleta
              </TabsTrigger>
            </TabsList>
          </Tabs>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-zinc-300">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="il-tuo-email@esempio.it"
                className="bg-zinc-950 border-zinc-800 focus:border-[#ccff00] focus:ring-1 focus:ring-[#ccff00] rounded-sm h-12 text-lg"
                required
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#ccff00] text-black hover:bg-[#b3e600] font-bold uppercase tracking-wide rounded-sm h-12 shadow-[0_0_15px_rgba(204,255,0,0.3)] hover:scale-[1.02] transition-all"
            >
              {loading ? 'Invio in corso...' : 'Invia Link di Reset'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
